import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export class ApplyLicenceResultModel extends BaseModel implements IRestModel {
    public message: string = null;
    public online: boolean = null;
    public readonly isIRestModel = true;

    public result: boolean = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-ApplyLicenceResultModel');
    }

    public toRestApiModel() {
        return RestModelUtility.toJson(this);
    }
}
